import * as _ from 'lodash';

import { combineReducers } from 'redux';
import { list } from './list/list.reducer';
import { detail } from './detail/detail.reducer';
import { edit } from './edit/edit.reducer';
import { create } from './create/create.reducer';
import { wizard } from './wizard/wizard.reducer';
import { ghost } from './ghost/ghost.reducer';
import { TemporaryPrice } from './temporary-price/temporary-price.reducer';
import { ADD_HISTORY_SUCCEEDED } from './product.action';

const history = (state = { items: []}, action) => {
  switch (action.type) {
    case ADD_HISTORY_SUCCEEDED:
      return {
        items: [...state.items, action.data]
      };
    default:
      return state;
  }
};
export const Product = combineReducers({
  history, list, detail, edit, create, wizard, ghost, TemporaryPrice
});
